import React, { useState } from "react";
import { Button, Input, Row, Col, Image } from "antd";
import { DeleteOutlined, CheckCircleFilled } from "@ant-design/icons";
import { RiImageAddFill as RiImageAddFillIcon } from "react-icons/ri";

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const dayOfWeek = date.toLocaleString('default', { weekday: 'long' });
    const monthName = date.toLocaleString('default', { month: 'long' });
    const day = date.getDate();
    const year = date.getFullYear();
    const getDaySuffix = (day) => {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };
    return `${dayOfWeek}, ${monthName} ${day}${getDaySuffix(day)}, ${year}`;
};

const SectionPhotoGrid = ({
    photos,
    sectionIndex,
    projectData,
    coverSettings,
    onUpdateCoverPhoto,
    onDeletePhoto,
    onUpdateDescription,
    onInsertPhoto,
    deletingPhotoId,
    savingPhotoDescId
}) => {
    const [editingPhotoDesc, setEditingPhotoDesc] = useState(null);
    const [descriptionValue, setDescriptionValue] = useState("");

    const handleSaveDescription = async (photoId) => {
        await onUpdateDescription(sectionIndex, photoId, descriptionValue);
        setEditingPhotoDesc(null);
    };

    return (
        <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
            {photos.map((photo, photoIndex) => (
                <Col className="single-section-photo" xs={24} md={24} key={`${photo.id}-${photoIndex}`}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                        <Button
                            className="button-photo-insert"
                            type="dashed"
                            icon={<RiImageAddFillIcon />}
                            size="small"
                            onClick={() => onInsertPhoto(sectionIndex, photoIndex)}
                            style={{ marginRight: '8px' }}
                        >
                            Insert Photo
                        </Button>
                    </div>
                    <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '8px' }}>
                        <Row gutter={[8, 8]}>
                            <Col xs={24} md={8} className="project-report-detail-image-section">
                                <div style={{ position: 'relative' }}>
                                    <div style={{ position: 'absolute', top: '-10px', right: '8px', background: '#1890ff', color: 'white', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold', zIndex: 1 }}>
                                        {photoIndex + 1}
                                    </div>
                                    {coverSettings.showCoverPhoto && (
                                        coverSettings.coverPhotoId === photo.id ? (
                                            <div style={{ position: 'absolute', top: '8px', left: '8px', background: '#52c41a', color: 'white', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold', zIndex: 2, display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                <CheckCircleFilled /> Cover Photo
                                            </div>
                                        ) : (
                                            <Button
                                                type="primary"
                                                size="small"
                                                icon={<CheckCircleFilled />}
                                                onClick={() => onUpdateCoverPhoto(photo.id)}
                                                style={{ position: 'absolute', top: '8px', left: '8px', zIndex: 2, fontSize: '12px', padding: '4px 8px', borderRadius: '8px', height: 'auto' }}
                                            >
                                                Make Cover Photo
                                            </Button>
                                        )
                                    )}
                                    <Image src={photo.inspection_image?.image_url || photo.image_url} style={{ width: '100%', height: '300px', objectFit: 'cover', borderRadius: '4px' }} />
                                </div>
                            </Col>
                            <Col xs={24} md={16}>
                                <div className="text-end mb-2">
                                    <Button
                                        danger
                                        size="small"
                                        icon={<DeleteOutlined />}
                                        onClick={() => onDeletePhoto(sectionIndex, photo.id)}
                                        loading={deletingPhotoId === photo.id}
                                    />
                                </div>

                                {/* Project Information */}
                                <div style={{ marginBottom: '12px', padding: '8px', background: '#f8f9fa', borderRadius: '4px', fontSize: '13px' }}>
                                    <div><strong>Project:</strong> {projectData?.name || 'N/A'}</div>
                                    <div><strong>Date:</strong> {photo.inspection_image?.created_at ? formatDate(photo.inspection_image.created_at) : 'N/A'}</div>
                                </div>

                                <div className="project-detail-image-description">
                                    {editingPhotoDesc === photo.id ? (
                                        <>
                                            <Input.TextArea
                                                style={{
                                                    border: "1px solid #75bdff",
                                                }}
                                                rows={4}
                                                value={descriptionValue}
                                                autoFocus
                                                onChange={(e) => setDescriptionValue(e.target.value)}
                                            />
                                            <Button
                                                style={{ marginTop: "6px", fontSize: '13px' }}
                                                type="primary"
                                                className="btn-GeneratePDF"
                                                size="small"
                                                onClick={() => handleSaveDescription(photo.id)}
                                                loading={savingPhotoDescId === photo.id}
                                            >
                                                Save
                                            </Button>
                                            <Button
                                                style={{ marginTop: "6px", marginLeft: "6px", fontSize: '13px' }}
                                                size="small"
                                                onClick={() => setEditingPhotoDesc(null)}
                                            >
                                                Cancel
                                            </Button>
                                        </>
                                    ) : (
                                        <Input.TextArea
                                            style={{
                                                border: "1px solid #edecec",
                                                padding: "4px 4px",
                                                borderRadius: "2px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {
                                                setEditingPhotoDesc(photo.id);
                                                setDescriptionValue(photo.inspection_image?.description || photo.description || "");
                                            }}
                                            rows={2}
                                            value={photo.inspection_image?.description || photo.description || "Click to add a description"}
                                            readOnly
                                        />
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            ))}
        </Row>
    );
};

export default SectionPhotoGrid;

